import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogClose} from '@angular/material/dialog';
import {MatIconModule} from '@angular/material/icon';
import {TranslocoPipe} from '@jsverse/transloco';
import {TextButton} from '../../../../shared/components/text-button/text-button.component';
import {CustomDatePipe} from '../../../../shared/pipes/custom-date-pipe';

export interface WaitlistConfirmData {
  icon: string;
  title: string;
  // line breaks in it are shown
  message?: string;
  slot?: {from: string, employeeName?: string | null};
  // a side effect worth stating before the patient confirms, shown as a highlighted note
  notice?: string;
  confirmLabel: string;
  confirmIcon: string;
  destructive?: boolean;
}

/**
 * Asks before booking, declining or leaving: each commits the patient to a time or takes an option
 * away, and a mis-tap on a phone is easy.
 *
 * The buttons close it through `mat-dialog-close` rather than `dialogRef.close()`: only the directive
 * tells Material whether the click came from a mouse or a keyboard. Without that, the button that
 * opened the dialog gets its focus back as "program" focus and stays highlighted after a mouse click.
 */
@Component({
  selector: 'app-waitlist-confirm',
  imports: [MatIconModule, MatDialogClose, TranslocoPipe, TextButton, CustomDatePipe],
  templateUrl: './waitlist-confirm.dialog.html',
  styleUrl: './waitlist-confirm.dialog.scss'
})
export class WaitlistConfirmDialog {
  constructor(@Inject(MAT_DIALOG_DATA) public data: WaitlistConfirmData) {
  }
}
